<div class="container-fluid mt-4">
  <div class="card">
    <div class="card-header">
      <div class="row">
        <h3>
          Whitelist & Templates
          <span class="btn-wrapper">
            <button type="button" class="btn btn-success btn-sm me-1">
              <fa-icon [icon]="['fal','sync']" (click)="reload()"></fa-icon>
            </button>
          </span>
          <span class="btn-wrapper" placement="top" [ngbTooltip]="canEdit? '':'Insufficent permission'" container="body">
            <button
              [disabled]="!canEdit"
              type="button"
              (click)="openCreateModal(false)"
              class="btn btn-primary btn-sm me-1"
              ngbTooltip="Add new whitelist entry for a single user"
              placement="right"
            >
              <fa-icon [icon]="['fal','plus']"></fa-icon> Create User
            </button>
          </span>

          <span class="btn-wrapper" placement="top" [ngbTooltip]="canEdit? '':'Insufficent permission'" container="body">
            <button
              [disabled]="!canEdit"
              type="button"
              (click)="openCreateModal(true)"
              class="btn btn-primary btn-sm"
              ngbTooltip="Add new whitelist entry for a group of users"
              placement="right"
            >
              <fa-icon [icon]="['fal','folder-plus']"></fa-icon> Create Group
            </button>
          </span>

          <span class="btn-wrapper">
            <button
              type="button"
              (click)="exportToCsv()"
              class="btn btn-outline-primary btn-sm ms-1"
              ngbTooltip="Export whitelisted users who have not registered yet"
              placement="right"
            >
              <fa-icon [icon]="'file-csv'"></fa-icon> Export CSV
            </button>
          </span>
        </h3>
      </div>
      <fa-icon class="card-header-icon bg-gradient-primary text-white" icon="address-card" size="lg" [fixedWidth]="true"> </fa-icon>
    </div>
    <div class="card-body">
      <user-page-view
        [entries]="entries"
        [columns]="columns"
        [roles]="roles | async"
        [clearSelection]="clearSelectionChange"
        (onUpdate)="openUpdateModal($event)"
        (onUpdated)="update($event)"
        (onUpdateMulti)="openUpdateMultiModal($event)"
        (onDelete)="delete($event)"
        (onDeleteMulti)="deleteMulti($event)"
        [canDelete]="canDelete"
        [canEdit]="canEdit"
      ></user-page-view>
    </div>
  </div>
</div>
